/* Cart drawer extras: the product suggestions list.
   Adding, changing and removing items is left to Dawn's own cart scripts. */
(function () {
  if (customElements.get('linovero-cart-upsell')) return;

  const loaded = new Map(); // recommendations url -> html of the cards
  const loading = new Map(); // recommendations url -> request in flight, shared by every copy of the drawer
  let lastCards = '';

  function load(url) {
    if (!loading.has(url)) {
      loading.set(
        url,
        fetch(url)
          .then((response) => (response.ok ? response.text() : ''))
          .then((text) => {
            const source = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-upsell-source]');
            loaded.set(url, source ? source.innerHTML : '');
            return loaded.get(url);
          })
          .catch((error) => {
            loading.delete(url);
            throw error;
          })
      );
    }
    return loading.get(url);
  }

  class CartUpsell extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-upsell-track]');
      if (!this.track) return;

      // Dawn's cart-items element treats every change event inside it as a quantity change
      this.addEventListener('change', (event) => {
        event.stopPropagation();
        this.onVariantChange(event.target);
      });

      const url = this.dataset.url;
      if (!url) return this.show();
      if (loaded.has(url)) {
        this.track.innerHTML = loaded.get(url);
        return this.show();
      }
      // while the new list loads, keep showing the previous one instead of leaving a gap
      if (lastCards) {
        this.track.innerHTML = lastCards;
        this.show();
      }
      load(url)
        .then((html) => {
          if (!this.isConnected) return;
          this.track.innerHTML = html;
          this.show();
        })
        .catch(() => {
          if (!lastCards) this.hidden = true;
        });
    }

    // drops products that are in the cart, keeps the first few, hides the block when nothing is left
    show() {
      const inCart = (this.dataset.inCart || '').split('|').filter(Boolean);
      const limit = parseInt(this.dataset.limit, 10) || 6;
      let kept = 0;
      this.track.querySelectorAll('[data-upsell-card]').forEach((card) => {
        if (inCart.includes(card.dataset.productId) || kept >= limit) card.remove();
        else kept++;
      });
      if (kept && this.dataset.url) lastCards = this.track.innerHTML;
      this.hidden = kept === 0;
    }

    onVariantChange(select) {
      const option = select.selectedOptions && select.selectedOptions[0];
      const card = select.closest('[data-upsell-card]');
      if (!option || !card) return;
      const price = card.querySelector('[data-upsell-price]');
      const compare = card.querySelector('[data-upsell-compare]');
      const image = card.querySelector('[data-upsell-image]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (image && option.dataset.image) image.src = option.dataset.image;
      const error = card.querySelector('.product-form__error-message-wrapper');
      if (error) error.hidden = true;
    }
  }

  customElements.define('linovero-cart-upsell', CartUpsell);
})();
